import { CONTRACT_TYPE_ID } from 'customer-data-objects/constants/ObjectTypeIds';
import { useAdditionalPropertyValues } from './useAdditionalPropertyValues';
import { isReadOnlyContractProperty } from 'customer-data-objects/contract/isReadOnlyContractProperty';
export const useIsReadOnlyContractProperty = (objectTypeId, propertyDefinition) => {
  const {
    data,
    loading
  } = useAdditionalPropertyValues({
    hs_type: 'hs_type'
  }, {
    skip: objectTypeId !== CONTRACT_TYPE_ID || !propertyDefinition.hubspotDefined
  });
  if (loading) {
    return true;
  }
  return isReadOnlyContractProperty({
    objectTypeId,
    propertyName: propertyDefinition.name,
    hubspotDefined: propertyDefinition.hubspotDefined,
    hs_type: data === null || data === void 0 ? void 0 : data.hs_type
  });
};